import { Controller } from '@hotwired/stimulus'
import consumer from '~/channels/consumer'

export default class extends Controller {
  static values = { accountId: String, tearsheetId: String }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: 'TearsheetActivityChannel', account_id: this.accountIdValue },
      { received: data => this.received(data) }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  received(data) {
    if (data.event !== 'tearsheet_viewed') return
    if (this.tearsheetIdValue && data.tearsheet_id !== this.tearsheetIdValue) return

    const item = document.createElement('li')
    const time = new Date(data.viewed_at).toLocaleString()
    item.textContent = `${data.viewer_email} (${data.share_name}) — ${time}`
    this.element.prepend(item)
  }
}
